import initQrPopup from 'components/qr-popup'
import { initForm } from 'landings/__assets__/scripts/components/form-handling-competition'
import { initNewsletter } from './../../../../assets/scripts/components/newsletter'

initQrPopup()
initNewsletter()
initForm({ termsCheckboxSelector: '[data-checkbox-field="promotion"]' })
